import React, { memo, MouseEvent } from 'react';
import { RuleBuilderField, RuleBuilderInput } from '..';
import * as GStyled from '../../../../styles/components';
import * as Styled from './styled';
import RuleBuilderActionMenu from '../rule-builder-item-action-menu/RuleBuilderActionMenu';
import RuleList from '../rule-list/RuleList';
import RuleBuilderItemButtonsBar from '../rule-builder-item-buttons-bar/RuleBuilderItemButtonsBar';
import { useIsFrs102Enabled } from '../../../../util/hooks/useIsFrs102Enabled';
import { replaceIfrsLabels } from '../../../../util/frs102Helper';

interface RuleBuilderItemProps {
  field: RuleBuilderField;
  className?: string;
  onAddRuleClick?: (e: MouseEvent) => void;
  onDeleteClick?: (e: MouseEvent) => void;
  onCancelClick?: () => void;
  onSaveClick?: () => void;
  onRemoveRuleClick?: (rule: RuleBuilderInput) => void;
  onEditRuleClick?: (rule: RuleBuilderInput) => void;
  onRuleChange?: (rule: RuleBuilderInput) => void;
}

function RuleBuilderItem({
  field,
  className,
  onAddRuleClick,
  onDeleteClick,
  onCancelClick,
  onSaveClick,
  onRemoveRuleClick,
  onEditRuleClick,
  onRuleChange,
}: RuleBuilderItemProps): JSX.Element {
  const isFrs102Enabled = useIsFrs102Enabled();
  const { rules } = field;
  const isEditing = rules.some((rule) => rule.isEditing);
  return (
    <Styled.RuleBuilderItemWrapper
      className={className}
      isHighlight={isEditing}
    >
      <Styled.RuleBuilderItem>
        <GStyled.Text>{replaceIfrsLabels(field.fieldName, isFrs102Enabled)}</GStyled.Text>
        <Styled.ItemError>
          <GStyled.Text color="basicRed">{field.err}</GStyled.Text>
        </Styled.ItemError>
        <RuleBuilderActionMenu
          onAddRuleClick={onAddRuleClick}
          onDeleteClick={onDeleteClick}
        />
      </Styled.RuleBuilderItem>
      <RuleList
        reportField={field}
        rules={rules}
        onRemoveRuleClick={onRemoveRuleClick}
        onEditRuleClick={onEditRuleClick}
        onRuleChange={onRuleChange}
      />
      {isEditing && (
        <RuleBuilderItemButtonsBar
          onCancelClick={onCancelClick}
          onSaveClick={onSaveClick}
        />
      )}
    </Styled.RuleBuilderItemWrapper>
  );
}

RuleBuilderItem.defaultProps = {
  field: {},
};

export default memo(RuleBuilderItem);
